<template>
    <breeze-authenticated-layout>
        <template #header>
            <div class="flex justify-between items-center">
                <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                    Chunking Exercise
                </h2>
                <div class="flex items-center space-x-3">
                    <inertia-link
                        :href="route('admin.chunking-lavel.index')"
                        class="
                            py-1
                            px-2
                            bg-indigo-500
                            text-white
                            rounded
                            focus:outline-none
                        "
                    >
                        Lavels
                    </inertia-link>
                    <button
                        @click="open = true"
                        class="
                            py-1
                            px-2
                            bg-indigo-500
                            text-white
                            rounded
                            focus:outline-none
                        "
                    >
                        Add Exercise
                    </button>
                </div>
            </div>
        </template>

        <div class="py-12">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div class="bg-white overflow-hidden shadow-sm sm:rounded-lg">
                    <div class="p-6 bg-white border-b border-gray-200">
                        <div class="flex flex-col">
                            <div
                                class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8"
                            >
                                <div
                                    class="
                                        py-2
                                        align-middle
                                        inline-block
                                        min-w-full
                                        sm:px-6
                                        lg:px-8
                                    "
                                >
                                    <div
                                        class="
                                            shadow
                                            overflow-hidden
                                            border-b border-gray-200
                                            sm:rounded-lg
                                        "
                                    >
                                        <table
                                            class="
                                                min-w-full
                                                divide-y divide-gray-200
                                            "
                                        >
                                            <thead class="bg-gray-50">
                                                <tr>
                                                    <th
                                                        scope="col"
                                                        class="
                                                            px-6
                                                            py-3
                                                            text-left text-xs
                                                            font-medium
                                                            text-gray-500
                                                            uppercase
                                                            tracking-wider
                                                        "
                                                    >
                                                        #
                                                    </th>
                                                    <th
                                                        scope="col"
                                                        class="
                                                            relative
                                                            px-6
                                                            py-3
                                                        "
                                                    >
                                                        <span class="sr-only"
                                                        >Edit</span
                                                        >
                                                    </th>
                                                    <th
                                                        scope="col"
                                                        class="
                                                            px-6
                                                            py-3
                                                            text-left text-xs
                                                            font-medium
                                                            text-gray-500
                                                            uppercase
                                                            tracking-wider
                                                        "
                                                    >
                                                        Title
                                                    </th>
                                                    <th
                                                        scope="col"
                                                        class="
                                                            px-6
                                                            py-3
                                                            text-left text-xs
                                                            font-medium
                                                            text-gray-500
                                                            uppercase
                                                            tracking-wider
                                                        "
                                                    >
                                                        Group Id
                                                    </th>
                                                    <th
                                                        scope="col"
                                                        class="
                                                            px-6
                                                            py-3
                                                            text-left text-xs
                                                            font-medium
                                                            text-gray-500
                                                            uppercase
                                                            tracking-wider
                                                        "
                                                    >
                                                        Levels Limit
                                                    </th>
                                                    <th
                                                        scope="col"
                                                        class="
                                                            px-6
                                                            py-3
                                                            text-left text-xs
                                                            font-medium
                                                            text-gray-500
                                                            uppercase
                                                            tracking-wider
                                                        "
                                                    >
                                                        Categories
                                                    </th>
                                                    <th
                                                        scope="col"
                                                        class="
                                                            px-6
                                                            py-3
                                                            text-left text-xs
                                                            font-medium
                                                            text-gray-500
                                                            uppercase
                                                            tracking-wider
                                                        "
                                                    >
                                                        Instructions
                                                    </th>
                                                    <th
                                                        scope="col"
                                                        class="
                                                            px-6
                                                            py-3
                                                            text-left text-xs
                                                            font-medium
                                                            text-gray-500
                                                            uppercase
                                                            tracking-wider
                                                        "
                                                    >
                                                        Info
                                                    </th>
                                                    <th
                                                        scope="col"
                                                        class="
                                                            px-6
                                                            py-3
                                                            text-left text-xs
                                                            font-medium
                                                            text-gray-500
                                                            uppercase
                                                            tracking-wider
                                                        "
                                                    >
                                                        Note
                                                    </th>
                                                    <th
                                                        scope="col"
                                                        class="
                                                            px-6
                                                            py-3
                                                            text-left text-xs
                                                            font-medium
                                                            text-gray-500
                                                            uppercase
                                                            tracking-wider
                                                        "
                                                    >
                                                       Result Note
                                                    </th>
                                                    <th
                                                        scope="col"
                                                        class="
                                                            px-6
                                                            py-3
                                                            text-left text-xs
                                                            font-medium
                                                            text-gray-500
                                                            uppercase
                                                            tracking-wider
                                                        "
                                                    >
                                                        Live
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody
                                                class="
                                                    bg-white
                                                    divide-y divide-gray-200
                                                "
                                            >
                                                <tr
                                                    v-for="(
                                                        exercise, index
                                                    ) in exercises"
                                                    :key="exercise.id"
                                                >
                                                    <td
                                                        class="
                                                            px-6
                                                            py-4
                                                            whitespace-nowrap
                                                        "
                                                    >
                                                        {{ index + 1 }}
                                                    </td>
                                                    <td
                                                        class="
                                                            px-6
                                                            py-4
                                                            whitespace-nowrap
                                                            text-right text-sm
                                                            font-medium
                                                        "
                                                    >
                                                        <button
                                                            @click="destroy(exercise)"
                                                            class="
                                                                text-red-400
                                                                hover:text-red-600
                                                                mx-3
                                                                focus:outline-none
                                                            "
                                                        >
                                                            Delete
                                                        </button>
                                                        <button
                                                            type="button"
                                                            @click="
                                                                edit(exercise)
                                                            "
                                                            class="
                                                                text-green-600
                                                                hover:text-green-900
                                                                mx-3
                                                                focus:outline-none
                                                            "
                                                        >
                                                            Edit
                                                        </button>
                                                    </td>
                                                    <td
                                                        class="
                                                            px-6
                                                            py-4
                                                            whitespace-nowrap
                                                        "
                                                    >
                                                        {{ exercise.title }}
                                                    </td>
                                                    <td
                                                        class="
                                                            px-6
                                                            py-4
                                                            whitespace-nowrap
                                                        "
                                                    >
                                                        {{ exercise.group_id }}
                                                    </td>
                                                    <td
                                                        class="
                                                            px-6
                                                            py-4
                                                            whitespace-nowrap
                                                        "
                                                    >
                                                        {{ exercise.options?.levels_limit }}
                                                    </td>
                                                    <td
                                                        class="
                                                            px-6
                                                            py-4
                                                            whitespace-nowrap
                                                        "
                                                    >
                                                        {{ exercise.category }}
                                                    </td>
                                                    <td
                                                        class="
                                                            px-6
                                                            py-4
                                                            text-sm
                                                            whitespace-pre
                                                            text-gray-500
                                                        "
                                                    >
                                                        <div
                                                            class="
                                                                max-w-xs
                                                                max-h-40
                                                                overflow-auto
                                                            "
                                                            v-html="
                                                                exercise.instructions
                                                            "
                                                        ></div>
                                                    </td>
                                                    <td
                                                        class="
                                                            px-6
                                                            py-4
                                                            text-sm
                                                            whitespace-pre
                                                            text-gray-500
                                                        "
                                                    >
                                                        <div
                                                            class="
                                                                max-w-xs
                                                                max-h-40
                                                                overflow-auto
                                                            "
                                                            v-html="
                                                                exercise.info
                                                            "
                                                        ></div>
                                                    </td>
                                                    <td
                                                        class="
                                                            px-6
                                                            py-4
                                                            text-sm
                                                            whitespace-pre
                                                            text-gray-500
                                                        "
                                                    >
                                                        <div
                                                            class="
                                                                max-w-xs
                                                                max-h-40
                                                                overflow-auto
                                                            "
                                                            v-html="
                                                                exercise.note
                                                            "
                                                        ></div>
                                                    </td><td
                                                        class="
                                                            px-6
                                                            py-4
                                                            text-sm
                                                            whitespace-pre
                                                            text-gray-500
                                                        "
                                                    >
                                                        <div
                                                            class="
                                                                max-w-xs
                                                                max-h-40
                                                                overflow-auto
                                                            "
                                                            v-html="
                                                                exercise.resultNote
                                                            "
                                                        ></div>
                                                    </td>
                                                    <td class="px-6 py-4">
                                                        <span
                                                            :class="{
                                                                'bg-green-100 text-green-800':
                                                                    exercise.live,
                                                                'bg-red-100 text-red-800':
                                                                    !exercise.live,
                                                            }"
                                                            class="
                                                                px-2
                                                                inline-flex
                                                                text-xs
                                                                leading-5
                                                                font-semibold
                                                                rounded-full
                                                            "
                                                        >
                                                            {{
                                                                exercise.live
                                                                    ? "Yes"
                                                                    : "No"
                                                            }}
                                                        </span>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </breeze-authenticated-layout>
    <dialog-model :show="open" @close="close">
        <template v-slot:title> {{ title }} </template>
        <template v-slot:content>
            <div class="grid grid-cols-1 lg:grid-cols-2 gap-4">
                <div class="block w-full">
                    <label
                        for="type"
                        class="block text-sm font-medium text-gray-700"
                        >Title</label
                    >
                    <input
                        v-model="form.title"
                        type="text"
                        name="title"
                        id="title"
                        autocomplete="organization-title"
                        class="
                            mt-1
                            focus:ring-indigo-500 focus:border-indigo-500
                            block
                            w-full
                            shadow-sm
                            sm:text-sm
                            border-gray-300
                            rounded-md
                        "
                    />
                    <input-error
                        v-if="form.hasErrors"
                        :message="form.errors.chunking_exercise.title"
                    />
                </div>
                <GroupidInput v-model="form.group_id" :data="group_id" :error="form.errors.chunking_exercise?.group_id"/>
                <div class="block w-full">
                    <label
                        for="levels_limit"
                        class="block text-sm font-medium text-gray-700"
                    >Levels Limit</label
                    >
                    <input
                        v-model="form.levels_limit"
                        type="number"
                        name="levels_limit"
                        id="levels_limit"
                        placeholder="Set levels Limit"
                        class="mt-1
                           focus:ring-indigo-500 focus:border-indigo-500
                           block
                           w-full
                           shadow-sm
                           sm:text-sm
                           border-gray-300
                           rounded-md"
                    />
                    <input-error
                        v-if="form.hasErrors"
                        :message="form.errors.chunking_exercise.levels_limit"
                    />
                </div>
                <div class="block w-full">
                    <label
                        for="top_label"
                        class="block text-sm font-medium text-gray-700"
                    >Top Label</label
                    >
                    <input
                        v-model="form.top_label"
                        type="text"
                        name="top_label"
                        id="top_label"
                        class="
                            mt-1
                            focus:ring-indigo-500 focus:border-indigo-500
                            block
                            w-full
                            shadow-sm
                            sm:text-sm
                            border-gray-300
                            rounded-md
                        "
                    />
                    <input-error
                        v-if="form.hasErrors"
                        :message="form.errors.chunking_exercise.top_label"
                    />
                </div>
                <div class="block w-full">
                    <label
                        for="bottom_label"
                        class="block text-sm font-medium text-gray-700"
                    >Bottom Label</label
                    >
                    <input
                        v-model="form.bottom_label"
                        type="text"
                        name="bottom_label"
                        id="bottom_label"
                        class="
                            mt-1
                            focus:ring-indigo-500 focus:border-indigo-500
                            block
                            w-full
                            shadow-sm
                            sm:text-sm
                            border-gray-300
                            rounded-md
                        "
                    />
                    <input-error
                        v-if="form.hasErrors"
                        :message="form.errors.chunking_exercise.bottom_label"
                    />
                </div>
                <div class="block w-full">
                    <label
                        for="category"
                        class="block text-sm font-medium text-gray-700"
                        >Category</label
                    >
                    <select
                        v-model="form.category"
                        id="category"
                        name="category"
                        autocomplete="off"
                        class="
                            mt-1
                            block
                            w-full
                            py-2
                            px-3
                            border border-gray-300
                            bg-white
                            rounded-md
                            shadow-sm
                            focus:outline-none
                            focus:ring-indigo-500
                            focus:border-indigo-500
                            sm:text-sm
                        "
                    >
                        <option value="">Select Category</option>
                        <option
                            v-for="category in categories"
                            :key="category.id"
                            :value="category.id"
                        >
                            {{ category.title }}
                        </option>
                    </select>
                    <input-error
                        v-if="form.hasErrors"
                        :message="form.errors.chunking_exercise.category"
                    />
                </div>

                <div class="block w-full">
                    <label
                        for="instructions"
                        class="block text-sm font-medium text-gray-700"
                        >Instructions</label
                    >
                    <textarea
                        v-model="form.instructions"
                        id="instructions"
                        name="instructions"
                        rows="3"
                        class="
                            shadow-sm
                            focus:ring-indigo-500 focus:border-indigo-500
                            mt-1
                            block
                            w-full
                            sm:text-sm
                            border border-gray-300
                            rounded-md
                        "
                    />
                    <input-error
                        v-if="form.hasErrors"
                        :message="form.errors.chunking_exercise.instructions"
                    />
                </div>
                <div class="block w-full">
                    <label
                        for="info"
                        class="block text-sm font-medium text-gray-700"
                        >Info</label
                    >
                    <textarea
                        v-model="form.info"
                        id="info"
                        name="info"
                        rows="3"
                        class="
                            shadow-sm
                            focus:ring-indigo-500 focus:border-indigo-500
                            mt-1
                            block
                            w-full
                            sm:text-sm
                            border border-gray-300
                            rounded-md
                        "
                    />
                    <input-error
                        v-if="form.hasErrors"
                        :message="form.errors.chunking_exercise.info"
                    />
                </div>
                <div class="block w-full">
                    <label
                        for="note"
                        class="block text-sm font-medium text-gray-700"
                    >Note</label
                    >
                    <textarea
                        v-model="form.note"
                        id="note"
                        name="note"
                        rows="3"
                        class="
                            shadow-sm
                            focus:ring-indigo-500 focus:border-indigo-500
                            mt-1
                            block
                            w-full
                            sm:text-sm
                            border border-gray-300
                            rounded-md
                        "
                    />
                    <input-error
                        v-if="form.hasErrors"
                        :message="form.errors.chunking_exercise.note"
                    />
                </div>
                <div class="block w-full">
                    <label
                        for="noteLive"
                        class="block text-sm font-medium text-gray-700"
                    >Note Live</label
                    >
                    <select
                        v-model="form.noteLive"
                        id="noteLive"
                        name="noteLive"
                        autocomplete="off"
                        class="
                            mt-1
                            block
                            w-full
                            py-2
                            px-3
                            border border-gray-300
                            bg-white
                            rounded-md
                            shadow-sm
                            focus:outline-none
                            focus:ring-indigo-500
                            focus:border-indigo-500
                            sm:text-sm
                        "
                    >
                        <option value="">Note is Live or not?</option>
                        <option value="1">Yes</option>
                        <option value="0">No</option>
                    </select>
                    <input-error
                        v-if="form.hasErrors"
                        :message="form.errors.chunking_exercise.noteLive"
                    />
                </div>
                <div class="block w-full">
                    <label
                        for="resultNote"
                        class="block text-sm font-medium text-gray-700"
                    >Result Note</label
                    >
                    <textarea
                        v-model="form.resultNote"
                        id="resultNote"
                        name="resultNote"
                        rows="3"
                        class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 mt-1 block w-full sm:text-sm border border-gray-300 rounded-md"
                    />
                    <input-error
                        v-if="form.hasErrors"
                        :message="form.errors.chunking_exercise.resultNote"
                    />
                </div>
                <div class="block w-full">
                    <label
                        for="resultNoteLive"
                        class="block text-sm font-medium text-gray-700"
                    >Result Note Live</label
                    >
                    <select
                        v-model="form.resultNoteLive"
                        id="resultNoteLive"
                        name="resultNoteLive"
                        autocomplete="off"
                        class="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                    >
                        <option value="">Note is Live or not?</option>
                        <option value="1">Yes</option>
                        <option value="0">No</option>
                    </select>
                    <input-error
                        v-if="form.hasErrors"
                        :message="form.errors.chunking_exercise.resultNoteLive"
                    />
                </div>
                <div class="block w-full">
                    <label
                        for="info_live"
                        class="block text-sm font-medium text-gray-700"
                    >Info Live</label
                    >
                    <select
                        v-model="form.info_live"
                        id="info_live"
                        name="info_live"
                        autocomplete="off"
                        class="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                    >
                        <option value="">Exercise info is Live or not?</option>
                        <option value="1">Yes</option>
                        <option value="0">No</option>
                    </select>
                    <input-error
                        v-if="form.hasErrors"
                        :message="form.errors.chunking_exercise.info_live"
                    />
                </div>
                <div class="block w-full">
                    <label
                        for="instructions_live"
                        class="block text-sm font-medium text-gray-700"
                    >Instructions Live</label
                    >
                    <select
                        v-model="form.instructions_live"
                        id="instructions_live"
                        name="instructions_live"
                        autocomplete="off"
                        class="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                    >
                        <option value="">Exercise instructions is Live or not?</option>
                        <option value="1">Yes</option>
                        <option value="0">No</option>
                    </select>
                    <input-error
                        v-if="form.hasErrors"
                        :message="form.errors.chunking_exercise.instructions_live"
                    />
                </div>
                <div class="block w-full">
                    <label
                        for="live"
                        class="block text-sm font-medium text-gray-700"
                        >Live</label
                    >
                    <select
                        v-model="form.live"
                        id="live"
                        name="live"
                        autocomplete="off"
                        class="
                            mt-1
                            block
                            w-full
                            py-2
                            px-3
                            border border-gray-300
                            bg-white
                            rounded-md
                            shadow-sm
                            focus:outline-none
                            focus:ring-indigo-500
                            focus:border-indigo-500
                            sm:text-sm
                        "
                    >
                        <option value="">Exercise is Live or not?</option>
                        <option value="1">Yes</option>
                        <option value="0">No</option>
                    </select>
                    <input-error
                        v-if="form.hasErrors"
                        :message="form.errors.chunking_exercise.live"
                    />
                </div>
            </div>
        </template>
        <template v-slot:footer>
            <button
                type="button"
                class="
                    w-full
                    inline-flex
                    justify-center
                    rounded-md
                    border border-transparent
                    shadow-sm
                    px-4
                    py-2
                    bg-green-600
                    text-base
                    font-medium
                    text-white
                    hover:bg-green-700
                    focus:outline-none
                    focus:ring-2
                    focus:ring-offset-2
                    focus:ring-green-500
                    sm:ml-3 sm:w-auto sm:text-sm
                "
                @click="submit()"
            >
                Save
            </button>
            <button
                type="button"
                class="
                    mt-3
                    w-full
                    inline-flex
                    justify-center
                    rounded-md
                    border border-gray-300
                    shadow-sm
                    px-4
                    py-2
                    bg-white
                    text-base
                    font-medium
                    text-gray-700
                    hover:bg-gray-50
                    focus:outline-none
                    focus:ring-2
                    focus:ring-offset-2
                    focus:ring-indigo-500
                    sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm
                "
                @click="close()"
                ref="cancelButtonRef"
            >
                Cancel
            </button>
        </template>
    </dialog-model>
</template>
<script>
import BreezeAuthenticatedLayout from "@/Layouts/Authenticated";
import DialogModel from "@/Components/DialogModel";
import InputError from "@/Components/InputError";
import { useForm } from "@inertiajs/inertia-vue3";
import GroupidInput from "@/Components/GroupidInput.vue";
export default {
    data() {
        return {
            open: false,
            editItemIndex: -1,
            form: useForm(
                {
                    id: "",
                    title: "",
                    category: "",
                    group_id: "",
                    instructions: "",
                    info: "",
                    live: "",
                    note: "",
                    noteLive: "",
                    resultNote: "",
                    levels_limit: "",
                    resultNoteLive: "",
                    top_label: '',
                    bottom_label: '',
                    info_live: '',
                    instructions_live: '',
                },
                {
                    bag: "chunking_exercise",
                }
            ),
        };
    },
    props: {
        exercises: Array,
        categories: Array,
        group_id: Array,
        format: String,
    },
    computed: {
        title() {
            return this.editItemIndex > -1
                ? "Edit This Exercise"
                : "Add A new Exercise";
        },
    },
    methods: {
        close() {
            this.form.clearErrors();
            this.form.reset();
            this.open = false;
            this.editItemIndex = -1;
        },
        submit() {
            if (this.editItemIndex > -1) {
                // update request
                this.form.put(
                    route(`admin.${this.format}.update`, this.form.id),
                    {
                        onSuccess: () => this.close(),
                        preserveScroll: true,
                    }
                );
            } else {
                // store request
                this.form.post(route(`admin.${this.format}.store`), {
                    onSuccess: () => this.close(),
                    preserveScroll: true,
                });
            }
        },
        edit(exercise) {
            this.editItemIndex = this.exercises.indexOf(exercise);
            this.form.title = exercise.title;
            this.form.category = exercise.category_id;
            this.form.group_id = exercise.group_id;
            this.form.top_label = exercise.options?.top;
            this.form.bottom_label = exercise.options?.bottom;
            this.form.levels_limit = exercise.options?.levels_limit;
            this.form.live = exercise.live ? 1 : 0;
            this.form.instructions = exercise.instructions;
            this.form.info = exercise.info;
            this.form.note = exercise.note;
            this.form.noteLive = exercise.noteLive ? 1 : 0;
            this.form.resultNote = exercise.resultNote;
            this.form.instructions_live = exercise.options?.instructions_live;
            this.form.info_live = exercise.options?.info_live;
            this.form.resultNoteLive = exercise.resultNoteLive ? 1 : 0;
            this.form.id = exercise.id;
            this.open = true;
        },
        destroy(exercise){
            if(confirm('Are you sure about deleting this item?')){
                this.$inertia.delete(route(`admin.${this.format}.destroy`,exercise.id))
            }
        }
    },
    components: {
        GroupidInput,
        BreezeAuthenticatedLayout,
        DialogModel,
        InputError,
    },
};
</script>
